import dayjs from 'dayjs';
import { useGlobal } from '@rcg/ui-react';
import Dictionary from './dictionary';

export const MILLISECONDS_IN_AN_HOUR = 3600000;

export const applyUtcFormatWithoutConverting = (date) => {
  const newDate = date.replace(/-/g, '/');
  return `${dayjs(newDate, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DDTHH:mm:ss')}.000Z`;
};

export const convertDateToMilliseconds = (date) => {
  return dayjs(date).valueOf();
};

export const getTimeRangeLabelForFilter = (
  localizedDayjs,
  dateInMilliseconds1,
  dateInMilliseconds2,
  abbreviatedWeekDays,
) => {
  const utcDate1 = localizedDayjs.utc(dateInMilliseconds1);
  const utcDate2 = localizedDayjs.utc(dateInMilliseconds2);
  return `${abbreviatedWeekDays[utcDate1.get('day')] || ''} ${utcDate1.format('H:mm')}${
    dateInMilliseconds1 === dateInMilliseconds2
      ? ''
      : ` - ${
          utcDate1.get('date') === utcDate2.get('date')
            ? ''
            : `${abbreviatedWeekDays[utcDate2.get('day')] || ''} `
        }${utcDate2.format('H:mm')}`
  }`;
};

export const timeWithLocale = (localizedDayjs, time) => {
  return localizedDayjs(time, 'H:mm').format('h:mm A');
};

const TimeDuration = (duration) => {
  const { renderContent } = useGlobal();

  const hours = Math.floor(duration / 60);
  const minutes = duration % 60;
  return `${
    hours === 0
      ? ''
      : `${hours}${renderContent(
          Dictionary.airFlightShortHoursLabel.key,
          Dictionary.airFlightShortHoursLabel.defaultValue,
        )}`
  } ${
    minutes === 0
      ? ''
      : `${minutes}${renderContent(
          Dictionary.airFlightShortMinutesLabel.key,
          Dictionary.airFlightShortMinutesLabel.defaultValue,
        )}`
  }`;
};

export default TimeDuration;
